import React, { useEffect } from "react";
import { Select, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import menuConfigurationActions from "../../../redux/menuConfiguration/actions";
import organizationAndRestaurantActions from "../../../redux/getOrganizationAndRestaurant/actions";
import { useProjectState } from "../../../context/stateContext";

const { getRestaurants } = organizationAndRestaurantActions;
const { syncMenuConfigurationImages, loadingSyncImages } =
  menuConfigurationActions;

const MenuConfigurationTabExtraContent = ({
  restaurantId,
  setRestaurantId,
}) => {
  const dispatch = useDispatch();
  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const { selectedOrganization } = useProjectState();

  const organizationId = localStorage.getItem("organizationId");

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const restaurantsOptions = restaurants.map((item) => {
    return {
      label: item.name,
      value: item.id,
    };
  });

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  return (
    <div className="menu-configuration-tab-extra-container">
      {defaultOrganization[0]?.multipleRestaurants && (
        <Select
          className="menu-configuration-tab-extra-restaurant-input"
          value={restaurantId}
          onChange={(value) => setRestaurantId(value)}
          options={restaurantsOptions}
        />
      )}
      <Button
        className="menu-configuration-tab-extra-sync-button"
        onClick={() => {
          dispatch(loadingSyncImages());
          dispatch(syncMenuConfigurationImages(organizationId));
        }}
      >
        Опресни
      </Button>
    </div>
  );
};

export default MenuConfigurationTabExtraContent;
